import { CognitoAuthError } from '@cpd-app/core-module/models';

export const cognitoAuthFeatureKey = 'cognitoAuth';
export interface CognitoAuthState {
  isAuthenticated: boolean;
  username: string;
  userId: string;
  isLoading: boolean;
  error: CognitoAuthError | null;
  isInProgress: boolean;
}

export const initialCognitoAuthState: CognitoAuthState = {
  username: null,
  userId: null,
  isAuthenticated: false,
  isLoading: false,
  error: null,
  isInProgress: false
};
